import { useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import CheckBox from 'components/form/CheckBox'
import { produce } from 'immer'
import Loading from 'components/loading/Loading'
import {
  CheckboxValues,
  DELETED,
  FilterMenus,
  OperationValues,
  ReviewStatusValues,
} from 'features/dashboard/filter/FilterSpecs'
import { SiteText } from 'features/shared/SiteUrlLink'
import HelpTooltip from 'components/tooltip/HelpTooltip'

const CheckBoxForm = () => {
  const { filterForm, setFilterForm } = useContext(FilterContext)
  const { isLoading, bizChannels, trackerRight, hasTrackerError } = useSelector(
    state => state.dashboard.filter
  )
  const { domain, key, data } = filterForm
  const items = useMemo(() => {
    if (key === 'bizChannels') {
      return bizChannels
    } else if (key === 'trackers') {
      return trackerRight
    } else if (key === 'reviewStatus') {
      return ReviewStatusValues[domain]
    } else if (key === 'operation') {
      return OperationValues[domain]
    } else {
      return CheckboxValues[key] || []
    }
  }, [key, domain, bizChannels, trackerRight])
  const deletedChecked =
    data.values.length === 1 && data.values[0] === DELETED.id
  const allChecked =
    data.values.length > 0 &&
    !deletedChecked &&
    data.values.length === items.length
  const { title } = FilterMenus[domain].subs.find(sub => sub.key === key)

  return (
    <>
      {key !== 'bizChannels' && key !== 'trackers' && (
        <ul className="list_layer">
          <li>
            <CheckBox
              label="전체"
              checked={allChecked}
              onCheckedChange={checked => {
                const values = checked ? items.map(({ id }) => id) : []
                setFilterForm(
                  produce(draft => {
                    draft.data.values = values
                  })
                )
              }}
            />
          </li>
        </ul>
      )}
      <ul className="list_layer">
        {isLoading ? (
          <Loading />
        ) : hasTrackerError ? (
          <p className="box_error">
            <span className="ico_comm" /> 일시적인 문제로 픽셀&amp;SDK를 불러올
            수 없습니다. 페이지를 새로고침 하세요.
          </p>
        ) : items.length === 0 ? (
          <li>{`${title}이 없습니다.`}</li>
        ) : (
          items.map(({ id, name, siteUrl = {} }) => {
            const index = data.values.indexOf(id)
            return (
              <li key={id}>
                <CheckBox
                  label={key === 'trackers' ? `${name} (${id})` : name}
                  value={id}
                  checked={index !== -1}
                  onCheckedChange={checked => {
                    if (checked) {
                      setFilterForm(
                        produce(draft => {
                          if (draft.data.values.includes(DELETED.id)) {
                            draft.data.values = []
                          }
                          draft.data.values.push(id)
                        })
                      )
                    } else {
                      setFilterForm(
                        produce(draft => {
                          if (index !== -1) draft.data.values.splice(index, 1)
                        })
                      )
                    }
                  }}
                />
                {siteUrl.pcUrl && (
                  <span className="txt_checkinp_url">
                    <SiteText siteUrl={siteUrl.pcUrl} />
                  </span>
                )}
                {siteUrl.mobileUrl && (
                  <span className="txt_checkinp_url">
                    <SiteText siteUrl={siteUrl.mobileUrl} />
                  </span>
                )}
              </li>
            )
          })
        )}
      </ul>
      {key === 'operation' && (
        <ul className="list_layer">
          <li>
            <CheckBox
              label={DELETED.name}
              checked={deletedChecked}
              onCheckedChange={checked => {
                const values = checked ? [DELETED.id] : []
                setFilterForm(
                  produce(draft => {
                    draft.data.values = values
                  })
                )
              }}
            />
            <HelpTooltip style={{ display: '' }} position="bottom">
              삭제 31일 후 미성과 데이터는
              <br />
              조회되지 않습니다.
            </HelpTooltip>
          </li>
        </ul>
      )}
    </>
  )
}

export default CheckBoxForm
